import { CREATE_INCOME_RANGE, CREATE_INCOME_RANGE_FAIL, CREATE_INCOME_RANGE_SUCCESS, UPDATE_INCOME_RANGE, UPDATE_INCOME_RANGE_FAIL, UPDATE_INCOME_RANGE_SUCCESS } from "./Constants"

export const createIncomeRange = (payload) =>{
    return{
        type: CREATE_INCOME_RANGE,
        payload
    }
}

export const createIncomeRangeSuccess = (payload) =>{
    return{
        type: CREATE_INCOME_RANGE_SUCCESS,
        payload
    }
}

export const createIncomeRangeFail = (payload) =>{
    return{
        type: CREATE_INCOME_RANGE_FAIL,
        payload
    }
}


export const updateIncomeRange = (payload) =>{
    return{
        type: UPDATE_INCOME_RANGE,
        payload
    }
}

export const updateIncomeRangeSuccess = (payload) =>{
    return{
        type: UPDATE_INCOME_RANGE_SUCCESS,
        payload
    }
}

export const updateIncomeRangeFail = (payload) =>{
    return{
        type: UPDATE_INCOME_RANGE_FAIL,
        payload
    }
}